export const agriculture_policy_framework = [
  {
    id: 1,
    name: 'strategic plan 2025-2030',
    summary: 'shortsummary/strategic plan 2025-2030.html',
    link: 'strategic plan 2025-2030.pdf',
    audio_en: 'audio/en/strategic plan 2025-2030_en.mp3',
    audio_af: 'audio/af/strategic plan 2025-2030_af.mp3',
    audio_xh: 'audio/xh/strategic plan 2025-2030_xh.mp3'
  }
];